<div 
    dati-fascicolo-view 
    *ngIf="!editMode && !!accordions[0].properties.fascicolo.id" 
    [fascicolo]="accordions[0].properties.fascicolo">
</div>
<ng-template #fascicoloForm appInsertionHost></ng-template>
<div style="height: 30px; width: 100%;"></div>
<div class="row" *ngIf="!!accordions[0].properties.fascicolo.id">
    <div class="col-sm-12">
        <button 
            aria-label="Modifica Dati" 
            *ngIf="!!accordions[0].properties.fascicolo.id && !this.editMode; else discard" 
            class="btn btn-primary edit"
            (click)="edit(true)">
                Modifica dati
        </button>
        <ng-template #discard>
            <button 
                aria-label="Chiudi" 
                class="btn btn-danger edit"
                (click)="edit(false)">
                    Chiudi
            </button>
        </ng-template>
    </div>
</div>
